module.exports = __webpack_public_path__ + "img/barcode.0b241be5.png";